<template>
  <div class="top">
    <van-nav-bar :title="title" fixed class="header-navbar">
      <!-- menu btn start -->
      <!-- <van-button slot="left" size="small">
        <van-icon name="wap-nav" />
      </van-button> -->
      <!-- menu btn end -->
      <!-- right tool menu start -->
      <van-button v-if="unlogin" slot="right" size="small" @click="toLogin()">
        注册/登录
      </van-button>
      <!-- <van-button v-else slot="right" size="small" @click="toLogout()">退出</van-button> -->

      <!-- right tool menu start -->
    </van-nav-bar>
  </div>
</template>
<script>
import { logout } from '@/api/theApi'
export default {
	props: {
		title: {
			type: String,
			default: 'Ainvest'
		},
		unlogin: {
			type: Boolean,
			default: true
		}
	},
	mounted() {
		// 确保导航栏固定定位正确
		this.$nextTick(() => {
			this.ensureNavbarFixed();
		});
	},
	methods: {
		toLogin() {
			this.$router.push({
				path: '/regLogin/1'
			})
		},
		toLogout() {
			localStorage.clear()
			logout()
			window.location.href = '/'
		},
		ensureNavbarFixed() {
			// 确保导航栏样式正确
			const navbar = this.$el.querySelector('.van-nav-bar');
			if (navbar) {
				navbar.style.position = 'fixed';
				navbar.style.top = '0';
				navbar.style.left = '0';
				navbar.style.right = '0';
				navbar.style.zIndex = '1000';
			}
		}
	}
}
</script>

<style lang="less" scoped>
.top {
  position: relative;
  z-index: 1000;
}

// 确保导航栏固定定位样式
.header-navbar {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
}

// 全局覆盖确保优先级
::v-deep .van-nav-bar {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
}
</style>
